import MainHeader from "../../layouts/MainHeader";
import VisionBackground from "../../assets/images/wallpaper/vision.jpg";
import visionPageData from "../../data/english/vision-page-data";
import Footer from "../../layouts/Footer";
import VisionCarousel from "../../components/carousel/VisionCarousel";

const VisionPage = () => {

  return (
    <main id="main" className="page">
      <div className="sticky-view-two">
        <div className="sticky-container">
          <MainHeader
            image={{
              src: VisionBackground,
              alt: "A beatifull view for city",
            }}
            title=""
          />
        </div>
        <div className="sticky-container-two" id="mainContent">
          <div className="wrapper-small">
            <h1 className="text-title">{visionPageData.title}</h1>
            <div className="space-50"></div>
            {/* <h2 className="text-title-normal">
              {visionPageData.sectionOne.title}
            </h2> */}
            <p className="text-paragraph">
              {visionPageData.sectionOne.paragraphOne}
            </p>
            <p className="text-paragraph">
              {visionPageData.sectionOne.paragraphTwo}
            </p>
            {/* <p className="text-paragraph">
              {visionPageData.sectionOne.paragraphThree}
            </p> */}
          </div>
          <VisionCarousel />
          <div className="margin-box"></div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
  );
};

export default VisionPage;
